{
  "title": "Zugriff",
  "subtitlePlatform": "Alle, die sich am Portal angemeldet haben. Wer ohne Einladung anmeldet, erscheint hier ohne Rolle und bleibt auf dem Wartebildschirm, bis Zugriff gewährt wird.",
  "subtitleTenant": "Personen mit Zugriff auf diesen Mandanten. Laden Sie jemanden ein, der sich noch nicht angemeldet hat, oder gewähren Sie Zugriff für jemanden, der es bereits hat.",
  "partnerTitle": "Partner-Team",
  "partnerSubtitle": "Personen, die dieses Partnerbuch verwalten können — Kunden einladen, Signaturen verwalten und weitere Partner-Administratoren einladen.",
  "partnerInviteHint": "Sie werden Partner-Administrator für dieses Buch. Die Anmeldung reicht — die Rolle gilt beim ersten Besuch.",
  "nobodyYetPartner": "Noch keine Partner-Administratoren außer offenen Einladungen. Laden Sie einen Kollegen mit der Anmeldeadresse ein.",
  "inviteSomebody": "Jemanden einladen",
  "grantAccess": "Zugriff gewähren",
  "waitingTitle": "Warten auf Annahme",
  "waitingHint": "Die Rolle wird bei der ersten Anmeldung automatisch angewendet.",
  "invitationsAria": "Offene Einladungen",
  "colInvited": "Eingeladen",
  "colExpires": "Läuft ab",
  "colWillReceive": "Erhält",
  "invitedBy": "von {{name}}",
  "withdraw": "Zurückziehen",
  "withdrawAria": "Einladung für {{email}} zurückziehen",
  "notWithdrawn": "Nicht zurückgezogen",
  "withdrawError": "Diese Einladung konnte nicht zurückgezogen werden.",
  "nobodyYet": "Noch niemand",
  "nobodyYetTenant": "Niemand hat Zugriff auf diesen Mandanten. Laden Sie jemanden ein — der Zugriff wartet bei der ersten Anmeldung.",
  "nobodyYetPlatform": "Noch niemand hat sich angemeldet. Laden Sie jemanden mit der Anmeldeadresse ein — die Rolle gilt sofort bei Ankunft.",
  "peopleAria": "Personen",
  "colPerson": "Person",
  "colLastSignIn": "Letzte Anmeldung",
  "colAccess": "Zugriff",
  "notRevoked": "Nicht widerrufen",
  "revokeError": "Konnte nicht widerrufen werden.",
  "noAccessYet": "Noch kein Zugriff",
  "revoke": "Widerrufen",
  "revokeOwnerOnly": "Nur ein Plattform-Eigentümer kann Eigentum widerrufen",
  "revokeAria": "{{role}}{{tenant}} widerrufen",
  "onTenant": " auf {{name}}",
  "nobodyToGrant": "Noch niemand zum Gewähren — diese Liste sind bereits angemeldete Personen. Laden Sie sie ein; die Rolle gilt bei Ankunft.",
  "personPlaceholder": "Jemanden wählen, der sich angemeldet hat",
  "role": "Rolle",
  "rolePlaceholder": "Rolle wählen",
  "tenant": "Mandant",
  "tenantPlaceholder": "Mandanten wählen",
  "grant": "Gewähren",
  "accessGranted": "Zugriff gewährt.",
  "notGranted": "Nicht gewährt",
  "grantError": "Konnte nicht gewährt werden.",
  "inviteTitle": "Jemanden einladen",
  "inviteHint": "Sie brauchen hier kein Konto. Anmeldung reicht — die Rolle unten gilt beim ersten Erscheinen.",
  "workEmail": "Geschäftliche E-Mail",
  "workEmailDesc": "Die Adresse, mit der sie sich anmelden.",
  "differentOrg": "Sie melden sich aus einer anderen Organisation an",
  "differentOrgDesc": "Für den Administrator eines Kunden aktivieren. Für Kollegen deaktiviert lassen.",
  "theirDirectory": "Ihr Verzeichnis",
  "theirDirectoryPlaceholder": "Entra-Mandanten-ID oder Google-Workspace-Domäne",
  "theirDirectoryDesc": "Gefragt, weil eine E-Mail-Adresse allein nichts beweist — jeder kann sie in einem kontrollierten Verzeichnis anlegen. Die Einladung gilt nur aus dem hier genannten Verzeichnis.",
  "sendInvitation": "Einladung senden",
  "invitedEmailed": "{{email}} eingeladen. E-Mail wurde gesendet.",
  "invitedNoEmailTitle": "{{email}} eingeladen",
  "invitedNoEmailBody": "Keine E-Mail gesendet — dieses Deployment hat keinen ausgehenden Mailversand. Bitten Sie sie, sich anzumelden; der Zugriff wartet.",
  "notInvited": "Nicht eingeladen",
  "inviteError": "Diese Person konnte nicht eingeladen werden.",
  "rolePlatformOwner": "Plattform-Eigentümer",
  "rolePlatformAdmin": "Plattform-Admin",
  "rolePartnerAdmin": "Partner-Admin",
  "roleTenantAdmin": "Mandanten-Admin",
  "roleEditor": "Bearbeiter",
  "roleDesigner": "Designer",
  "roleViewer": "Betrachter",
  "roleDescOwner": "Alles, einschließlich Eigentum an andere vergeben.",
  "roleDescAdmin": "Verwaltet alle Mandanten. Kann keine Plattformrollen vergeben.",
  "roleDescPartnerAdmin": "Verwaltet jeden Kunden in diesem Partnerbuch und wer sonst das Buch verwalten darf.",
  "roleDescTenantAdmin": "Volle Kontrolle über einen Mandanten inklusive Zugriffsliste.",
  "roleDescEditor": "Bearbeitet Vorlagen, Regeln und Kampagnen.",
  "roleDescDesigner": "Bearbeitet nur Vorlagen.",
  "roleDescViewer": "Nur Lesen."
}
